import React from 'react';
import { connect } from 'react-redux';
import Tooltip from 'material-ui/Tooltip';

import DropSimple from '../Drop';
import TrophyIcon from '../../../../lib/icons/TrophyIcon';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import Console from '../../../../lib/debug';

class BlockMenuLeaderboard extends React.Component {
    updateLeaderboardValue(value) {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        DesignerState.updateBlock(dispatch, block, 'redzone_type', value.id);
    }
    render() {
        Console.render('designer.BlockMenuLeaderboard');
        let block = this.props.block;
        let leaderboardTypesRef = this.props.leaderboardTypesRef;
        if (
            leaderboardTypesRef &&
            leaderboardTypesRef[0].title === 'For Completion'
        ) {
            leaderboardTypesRef[0].title = '-';
        }

        let classes = 'menu-leaderboard';
        if (block.redzone_type > 0) {
            classes += ' on';
        } else {
            classes += ' lb-off';
        }

        let toolTip = 'Create a Leaderboard to increase athlete competition.';

        return (
            <Tooltip title={toolTip}>
                <div className={classes}>
                    <TrophyIcon className="trophy-icon" />
                    <DropSimple
                        value={block.redzone_type}
                        placeholder="Add Leaderboard"
                        labelKey="title"
                        valueKey="id"
                        clearable={false}
                        searchable={false}
                        options={leaderboardTypesRef}
                        onChange={this.updateLeaderboardValue.bind(this)}
                    />
                </div>
            </Tooltip>
        );
    }
}

let mapStateToProps = function(state, ownProps) {
    return {
        ...ownProps,
        leaderboardTypesRef: state.library.leaderboardTypesRef.lbTypes
    };
};

export default connect(mapStateToProps)(BlockMenuLeaderboard);
